// extracted by mini-css-extract-plugin
export default {"container":"SideMenu_container__wZn1r","mobileFlexCenter":"SideMenu_mobileFlexCenter__mhgHe","navBox":"SideMenu_navBox__p1vIL","bgBlue":"SideMenu_bgBlue__n4S4y"};